class ModulePagination {
    constructor(list = [], handle, option = {
        paged: 1,
        page_per_view: 12,
    }) {
        if (!list || list.length === 0){
            if (handle){
                handle.innerHTML = "";
                handle.style.marginTop = 0;
            }
            return;
        }
        if (!handle){
            handle = document.createElement('div');
            handle.classList.add('pagination-handle');

            const parent = list[0].parentNode.parentNode;
            const nextSibling = list[0].parentNode.nextSibling

            parent.insertBefore(handle, nextSibling);
        }
        handle.style.marginTop = "";

        const totalPages = Math.ceil(list.length / option.page_per_view);
        if (totalPages <= 1){
            handle.style.display = "none";
        }

        this._list = list;
        this._handle = handle;
        this._paged = option.paged;
        this._page_per_view = option.page_per_view;
        
        this.init();
    }

    getList() {
        return this._list;
    }

    getHandle() {
        return this._handle;
    }

    getPaged() {
        return this._paged;
    }

    getPagePerView() {
        return this._page_per_view;
    }

    get() {
        return {
            list: this._list,
            handle: this._handle,
            paged: this._paged,
            page_per_view: this._page_per_view,
        };
    }

    init() {
        this.handlePagination();
        this.change();
    }


    handlePagination() {
        const { list, handle } = this.get();

        handle.innerHTML = this.pagination(this._paged, Math.ceil(this._list.length / this._page_per_view));
        const linkPages = handle.querySelectorAll('a[data-page]');
        
        let isProcessed = false;

        linkPages.forEach(link => {
            link.onclick = (e) => {
                e.preventDefault();
                if (!!isProcessed) return;
                isProcessed = true;

                const wrapper = handle.parentElement.querySelector('.pagination-wrapper');
                if (wrapper){
                    wrapper.classList.add('spinner');
                }

                setTimeout(() => {
                    const newPage = parseInt(link.dataset.page, 10);
                    this.setPage(newPage);
    
                    if (wrapper){
                        wrapper.classList.remove('spinner');
                    }

                    isProcessed = false;
                    let offsetTop = getOffsetTop(list[0].closest('section'));

                    window.scrollTo({
                        top: offsetTop,
                        behavior: 'smooth'
                    })
                }, 100)
            };
        });

        function getOffsetTop(element) {
            const rect = element.getBoundingClientRect();
            let header = document.querySelector('.header');
            let headerValue = getComputedStyle(document.body)
                .getPropertyValue('--header-sticky-menu')
                .trim();
            if (headerValue){
                let headerHeight = parseInt(headerValue, 10);
    
                return rect.top + window.scrollY - headerHeight;
            }

            if (header){
                return rect.top + window.scrollY - header.clientHeight;
            }
            return rect.top + window.scrollY;
        }
    }

    setPage(newPage) {
        this._paged = newPage;
        this.change();
        this.handlePagination();
    }

    change() {
        const { list } = this.get();
        
        list.forEach((item, idx) => {
            const PageOfItem = Math.floor(idx / this._page_per_view) + 1;
            item.style.display = (PageOfItem === this._paged) ? "" : "none";
        });
    }

    
    pagination(currentPage, totalPages) {
        if (totalPages <= 1) return '';

        let paginationHTML = '';
        let display;
        let next = '<svg fill=none height=14 viewBox="0 0 8 14"width=8 xmlns=http://www.w3.org/2000/svg><path d="M1.01341 1L7 7L1.01341 13"stroke=#4D5761 stroke-linecap=round /></svg>';
        let prev = '<svg fill=none height=14 viewBox="0 0 8 14"width=8 xmlns=http://www.w3.org/2000/svg><path d="M6.98659 1L1 7L6.98659 13"stroke=#4D5761 stroke-linecap=round /></svg>';

        // Previous button
        if (currentPage > 1) {
            paginationHTML += `<a href="#" data-page="${currentPage - 1}" class="prev page-number">${prev}</a>`;
        }

        // First page
        if (currentPage > 2) {
            display = `0${1}`;
            paginationHTML += `<a href="#" data-page="1" class="page-number">${display}</a>`;
        }

        // Ellipsis before current page range
        if (currentPage > 3) {
            paginationHTML += `<span class="dots page-number">...</span>`;
        }

        // Page numbers around the current page
        let startPage = Math.max(1, currentPage - 1);
        let endPage = Math.min(totalPages, currentPage + 1);

        for (let i = startPage; i <= endPage; i++) {
            display = i < 10 ? `0${i}` : i;
            paginationHTML += (i === currentPage) 
                ? `<span class="active page-number">${display}</span>`
                : `<a href="#" data-page="${i}" class="page-number">${display}</a>`;
        }

        // Ellipsis after current page range
        if (currentPage < totalPages - 2) {
            paginationHTML += `<span class="dots page-number">...</span>`;
        }

        // Last page
        if (currentPage < totalPages - 1) {
            display = totalPages < 10 ? `0${totalPages}` : totalPages;
            paginationHTML += `<a href="#" data-page="${totalPages}" class="page-number">${display}</a>`;
        }

        // Next button
        if (currentPage < totalPages) {
            paginationHTML += `<a href="#" data-page="${currentPage + 1}" class="next page-number">${next}</a>`;
        }

        return paginationHTML;
    }

    destroy() {
        if (!this._handle){
            return;
        }
        const linkPages = this._handle.querySelectorAll('a[data-page]');
        linkPages.forEach(link => {
            link.onclick = null;
        });

        this._list = null;
        this._handle = null;
    }
}

export default ModulePagination;